import {
    ADD_PROXIES,
    GET_PROXY_USER_LIST,
    GET_PROXY_LIST,
    REVOKE_PROXIES,
    INITIATE_PROXY,
    UPDATE_PROXY,
    TERMINATE_PROXY,
    SET_UPDATE_POPUP,
} from 'src/pages/more/pages/proxies/redux/action/actionTypes.js';

export const addProxies = (data) => {
    return {
        type: ADD_PROXIES,
        payload: data,
    };
};

export const updateProxies = (data) => {
    return {
        type: UPDATE_PROXY,
        payload: data,
    };
};

export const getProxyUserList = (data) => {
    return {
        type: GET_PROXY_USER_LIST,
        payload: data,
    };
};
export const getProxyList = () => {
    return {
        type: GET_PROXY_LIST,
        // payload: data,
    };
};
export const setRevokeProxy = (data) => {
    return {
        type: REVOKE_PROXIES,
        payload: data,
    };
};
export const initiateProxy = (data) => {
    return {
        type: INITIATE_PROXY,
        payload: data,
    };
};
export const terminateProxy = () => {
    return {
        type: TERMINATE_PROXY,
    };
};
export const setUpdatePopup = (payload) => {
    return {
        type: SET_UPDATE_POPUP,
        payload: payload,
    };
};
